import { render, staticRenderFns } from "./dictIndexhouse.vue?vue&type=template&id=5364ed5c&scoped=true"
import script from "./dictIndexhouse.vue?vue&type=script&lang=js"
export * from "./dictIndexhouse.vue?vue&type=script&lang=js"
import style0 from "./dictIndexhouse.vue?vue&type=style&index=0&id=5364ed5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5364ed5c",
  null
  
)

export default component.exports